// extracted by mini-css-extract-plugin
module.exports = {"InfoIcon":"app-javascript-works-data_modal-info_icon-style__InfoIcon--3DHuC"};